import { ModuleCodes } from '../../../../models/modules';
import { WebSocketsReservationEvents, WebSocketsTripEvents } from '../../../../models/web-sockets';

const mServerTable = {
  footer: {
    selectAll: 'Select All',
    allPageSelected: {
      text: 'All {{number}} items on this page are selected.',
      action: 'Select all {{number}} items',
    },
    allPagesSelected: {
      text: 'All {{number}} items in the table are selected.',
      action: 'Clear Selection',
    },
  },
  noResults: 'No Results',
  total: 'Total',
  generalSearch: 'Search',
  actions: {
    more: 'More',
    clearFilters: 'Clear Filters',
    hiddenColumns: 'Hidden Columns',
    refreshTable: 'Refresh Table',
  },
  floatingActions: {
    extraActionsMenu: {
      button: 'More',
      title: 'More Actions',
    },
    selectedText: {
      single: 'Item selected',
      many: 'Items selected',
    },
  },
  updates: {
    [ModuleCodes.Trips]: {
      [WebSocketsTripEvents.New]: 'New',
      [WebSocketsTripEvents.Update]: 'Update',
      [WebSocketsTripEvents.Cancel]: 'Cancelation',
      [WebSocketsTripEvents.StatusChange]: 'Status change',
    },
    [ModuleCodes.Reservations]: {
      [WebSocketsReservationEvents.New]: 'New',
      [WebSocketsReservationEvents.Update]: 'Update',
      [WebSocketsReservationEvents.Cancel]: 'Cancelation',
      [WebSocketsReservationEvents.StatusChange]: 'Status change',
    },
  },
};

export default mServerTable;
